import React from "react";
import T from "prop-types";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import { childrenType } from "2g-types";

export function ZadostiRowDetailColumn({ classname = "", label, children }) {
  return (
    <div className={cn("b2b-ZadostiRowDetail-column", classname)}>
      {label ? (
        <div className="b2b-ZadostiRowDetail-label">
          <FormattedMessage id={label} defaultMessage={label} />
        </div>
      ) : undefined}
      {children}
    </div>
  );
}

ZadostiRowDetailColumn.propTypes = {
  classname: T.string,
  label: T.string,
  children: childrenType
};

export default React.memo(ZadostiRowDetailColumn);
